"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class OnboardingService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'requests';
        this.getOnboardingCatModality = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/onboarding/catmodality`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getOnboardingSkillHierarchy = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/onboarding/skillhierarchy`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.registerPersonOnboardingRel = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/onboarding`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.OnboardingService = OnboardingService;
